import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import ptBR from '@/locales/pt-BR.json';

try {
  localStorage.removeItem('i18nextLng');
} catch {
  // Armazenamento indisponível (ex.: navegação privada).
}

const resources = {
  'pt-BR': {
    translation: ptBR,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;